/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { RegisterReconcileList } from "../../types";
import { PaginationType } from "../../../../types"


type UseRegisterReconcileList = {
  params: {
    coa_id: string;
    start_date: string;
    end_date: string;
    page: number;
    limit: number;
  };
  onSuccess?: (data: RegisterReconcileList[]) => void;
};

type Response = {
  payload: RegisterReconcileList[];
  pagination_data: PaginationType;
};

export function useRegisterReconcileList({
  params,
  onSuccess
}: UseRegisterReconcileList) {
  const api = useApi();
  const [data, setData] = useState<RegisterReconcileList[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const fetchData = () => {
    if (
      !params.coa_id ||
      !params.start_date ||
      !params.end_date
    )
      return;

    setLoading(true);

    api
      .get("reconciliation", { params })
      .then((res: SuccessFetch<Response>) => {
        const payload = res.data;
        const data = res.data.payload.map((item) => ({ ...item, rc: false }));

        onSuccess?.(data);
        setData(data);
        setPagination(payload.pagination_data);
      })
      .catch(() => {
        setData([])
        setPagination(null);
      })
      .finally(() => setLoading(false));
  };

  // const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, [
    params.coa_id,
    params.start_date,
    params.end_date,
    params.page, 
    params.limit
  ]);

  return { data, isLoading, fetchData, pagination  };
}
